import { Box, Grid, TextField } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";

const YearPicker = ({ setYear, index, yearFrom, yearTo, defValue }) => {
  const dispatch = useDispatch();
  const [selectedYear, setSelectedYear] = useState(defValue? new Date(defValue, 0) : null)

  useEffect(() => {
    setSelectedYear(defValue ? new Date(defValue, 0) : null);
  }, [defValue]);

  const handleYearChange = (newValue) => {
    if (newValue !== null) {
      const selectedDate = new Date(newValue);
      const selectYear = selectedDate.getFullYear();
      setSelectedYear(new Date(selectYear, 0, 1));
      dispatch(setYear(index !== undefined ? { index: index, short: selectYear } : selectYear));
    }
  };

  return (
    <Box display="flex" justifyContent="start" style={{ width: "100%" }}>
      <Grid
        style={{ width: "100%" }}
        justifyContent={"start"}
        display={"flex"}
        flexDirection={"row"}
        textAlign={"start"}
        width={"100%"}
      >
        <LocalizationProvider dateAdapter={AdapterDayjs} style={{ width: "100%" }}>
          <DatePicker
            style={{ width: "100%" }}
            views={["year"]}
            label="Year"
            value={selectedYear}
            onChange={handleYearChange}
            minDate={new Date(yearFrom, 0)} // Set minimum date to January of yearFrom
            maxDate={new Date(yearTo, 11)} // Set maximum date to December of yearTo
            renderInput={(params) => (
              <TextField
                style={{ width: "100%" }}
                {...params}
                size="small"
                helperText={null}
                inputProps={{ ...(params.inputProps || {}), readOnly: true }}
              />
            )}
          />
        </LocalizationProvider>
      </Grid>
    </Box>
  );
};

export default YearPicker;
